var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.25C6.3025 3.25 6.55 3.4975 6.55 3.8V6C6.55 6.3025 6.3025 6.55 6 6.55C5.6975 6.55 5.45 6.3025 5.45 6V3.8C5.45 3.4975 5.6975 3.25 6 3.25ZM5.9945 0.5C2.9585 0.5 0.5 2.964 0.5 6C0.5 9.036 2.9585 11.5 5.9945 11.5C9.036 11.5 11.5 9.036 11.5 6C11.5 2.964 9.036 0.5 5.9945 0.5ZM6 10.4C3.569 10.4 1.6 8.431 1.6 6C1.6 3.569 3.569 1.6 6 1.6C8.431 1.6 10.4 3.569 10.4 6C10.4 8.431 8.431 10.4 6 10.4ZM6.55 8.75H5.45V7.65H6.55V8.75Z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWarningIcon);
export default __webpack_public_path__ + "static/media/StatusWarningIcon.7ff5439c2b152e4674c6152e78a92ff0.svg";
export { ForwardRef as ReactComponent };